var BaseViews = require('../base');
var CartReview = require('./cart-review');
var CartPayment = require('./cart-payment');
var CartPaymentChallenge = require('./cart-payment-challenge');
var CartEmpty = require('./cart-empty');
var OrderComplete = require('./order-complete');
var CartLoading = require('./cart-loading');
var LocationMap = require('../locations-map');

require('./cart-expanded-modal/cart-expanded-modal.scss');
var CartExpandedModal = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-expanded-modal fmcy-plugin-bootstrap container-fluid',
    template: require('./cart-expanded-modal/cart-expanded-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                errors: null,
                errorMessage: null,
                errorField: null,
                orderId: null,
                showCloseButton: true,
                state: 'default' //default, success
            }
        );
    },
    ui: {
      btnClose: '.fmcy-menu-item-btn-close'
    },
    triggers: {
      'click @ui.btnClose': 'close:clicked'
    },
    regions: {
        cartStepRegion: '.fmcy-cart-step-region',
        mapRegion: '.fmcy-location-map-region'
    },
    _renderMap: function (options) {
      if (this._locationMap) {
        return;
      }
      this._locationMap = new LocationMap(_.extend(options, {
        allLocations: false,
        adjustForMenuBar: false,
        showCloseButton: false,
        showZoomControls: false,
        scrollWheelZoom: false,
        _appChannel: this.options._appChannel
      }));
      this.mapRegion.show(this._locationMap);
    },
    _renderOrderComplete: function () {
      this._orderComplete = new OrderComplete({
        orderId: this.options.orderId, //TODO: pass more order details?
        order: this.options.order,
        location: this.options._appChannel.request('get:filter:location:details')
      });
      this.cartStepRegion.show(this._orderComplete);
    },
    _renderCartPayment: function () {
      var self = this;
      self._cartPayment = new CartPayment({
        _appChannel: self.options._appChannel,
        errors: self.options.errors,
        errorMessage: self.options.errorMessage,
        errorField: self.options.errorField
      });
      self.cartStepRegion.show(self._cartPayment);
    },
    _renderCartPaymentChallenge: function () {
      var self = this;
      self._cartPaymentChallenge = new CartPaymentChallenge(self.options);
      self.cartStepRegion.show(self._cartPaymentChallenge);
    },
    _renderCartReview: function () {
      var self = this;
      this.options._appChannel.request('cart:validate:prices').then(function (response) {
        self._cartReview = new CartReview({
          _appChannel: self.options._appChannel,
          errors: self.options.errors,
          errorMessage: self.options.errorMessage
        });
        self.cartStepRegion.show(self._cartReview);
      }).fail(function (response) {
        console.log('failed...');
        // failed... should do something...
      });
    },
    _renderCartEmpty: function () {
      var self = this;
      self._cartEmpty = new CartEmpty({
        _appChannel: self.options._appChannel,
      });
      self.cartStepRegion.show(self._cartEmpty);
    },
    _renderCartLoading: function () {
      if (this.cartStepRegion) {
        this._cartLoading = new CartLoading({
          _appChannel: this.options._appChannel
        });
        this.cartStepRegion.show(this._cartLoading);
      }
    },
    _renderState: function (state) {
      switch (state) {
        case 'success':
          this._renderOrderComplete();
        break;
        case 'payment':
          this._renderCartPayment();
          if ($(window).width() > 991) {
            this._renderMap({
              animate: false
            });
          }
        break;
        case 'challenge':
          this._renderCartPaymentChallenge();
        break;
        default:
          this._renderCartLoading();
          if (this.options._appChannel.request('cart:get:items:count') > 0) {
            this._renderCartReview();
          } else {
            this._renderCartEmpty();
          }

          if ($(window).width() > 991) {
            this._renderMap({
              animate: true
            });
          }
        break;
      }
      if (this.options.showCloseButton) {
        this.ui.btnClose.show();
      } else {
        this.ui.btnClose.hide();
      }
    },
    ChangeState: function (options) {
      // clear errors from options
      if (this.options.errors !== null) {
        this.options.errors = null;
      }
      if (this.options.errorMessage !== null) {
        this.options.errorMessage = null
      }
      _.extend(this.options, options);
      this._renderState(options.state);
    },
    onShow: function() {
      var self = this;
      this._renderState(this.options.state);
      this.listenTo(this.options._appChannel, 'cart:validate', function () {
          self._renderCartLoading();
      });
    },
    onDestroy: function () {
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = CartExpandedModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-expanded-modal.js
 **/